import {
    ReportTableConfigInterface,
    ReportTableActionMenuTypesEnum,
    ReportTableData, ReportTableColumn
} from '../../../app/shared/components';

export const BankAccountNameSelector = 'name';
export const BankAccountIbanSelector = 'iban';
export const BankAccountBicSelector = 'bic';
export const BankAccountAccountNumberSelector = 'accountNumber';
export const BankAccountSortCodeSelector = 'sortCode';
export const BankAccountStatusSelector = 'active';
export const CryptoWalletSelector = 'crypto_wallet_address';
export const CryptoNetworkSelector = 'crypto_network_code';
export const PanelClientsEditBankAccountsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: BankAccountNameSelector,
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: BankAccountBicSelector,
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: BankAccountSortCodeSelector,
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: BankAccountIbanSelector,
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: BankAccountAccountNumberSelector,
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: BankAccountStatusSelector,
            value: null,
            hidden: false

        })
    ];
};

export const PanelClientsEditBankAccountsDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Bank Name',
                selector: BankAccountNameSelector
            }),
            new ReportTableColumn({
                label: 'BIC',
                selector: BankAccountBicSelector
            }),
            new ReportTableColumn({
                label: 'Sort Code',
                selector: BankAccountSortCodeSelector
            }),
            new ReportTableColumn({
                label: 'IBAN',
                selector: BankAccountIbanSelector
            }),
            new ReportTableColumn({
                label: 'Account Number',
                selector: BankAccountAccountNumberSelector
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: BankAccountStatusSelector
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false,
        actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
        actionMenuItems: []
    };
};

export const PanelClientsEditCryptoWalletsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: CryptoWalletSelector,
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: CryptoNetworkSelector,
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: BankAccountStatusSelector,
            value: null,
            hidden: false

        })
    ];
};

export const PanelClientsEditCryptoWalletsDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Wallet Address',
                selector: CryptoWalletSelector
            }),
            new ReportTableColumn({
                label: 'Network',
                selector: CryptoNetworkSelector
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: BankAccountStatusSelector
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false,
        actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
        actionMenuItems: []
    };
};
